var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layoutStyle,{tag:"component",attrs:{"hiddenHeader":true,"hiddenFooter":false}},[_c(_vm.mainStyle,{tag:"component",attrs:{"home-info":_vm.homeInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }